function lbougePatchCartBubble(html) {
  /* Update ONLY the count bubble in place. Never replace the cart icon or its children: apps like WeUpsell
     bind their click handlers to them, and replacing them hands the click back to the theme drawer. */
  try {
    var link = document.getElementById('cart-icon-bubble');
    if (!link || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('.cart-count-bubble');
    var cur = link.querySelector('.cart-count-bubble');
    if (next && cur) { if (cur.innerHTML !== next.innerHTML) cur.innerHTML = next.innerHTML; }
    else if (next && !cur) link.appendChild(document.importNode(next, true));
    else if (!next && cur) cur.remove();
  } catch (e) {}
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      // synthetic click from the popup's "View cart": leave it to the app's own trigger handler
      if (window.__lbougeAppClick) return;
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (section.id === 'cart-icon-bubble') return lbougePatchCartBubble(parsedState.sections[section.id]);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


/* ---------------------------------------------------------------
   Keep the header cart count bubble in sync with the real cart.
   Watches every /cart/add, /cart/change, /cart/update and /cart/clear
   request (from the theme, WeUpsell or any other script) and
   re-renders the bubble from the server once the request finishes.
   --------------------------------------------------------------- */
(function () {
  if (window.__cartBubbleSyncInstalled) return;
  window.__cartBubbleSyncInstalled = true;

  const CART_URL_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;
  const origFetch = window.fetch ? window.fetch.bind(window) : null;
  let timer;

  function syncBubble() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !origFetch) return;
      origFetch(`${window.location.pathname}?sections=cart-icon-bubble&_=${Date.now()}`)
        .then((r) => r.json())
        .then((data) => {
          const html = data && data['cart-icon-bubble'];
          if (!html) return;
          lbougePatchCartBubble(html);
        })
        .catch(() => {});
    }, 200);
  }

  if (origFetch) {
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const request = origFetch(input, init);
      if (CART_URL_RE.test(url)) request.then(syncBubble, () => {});
      return request;
    };
  }

  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_URL_RE.test(url)) {
      this.addEventListener('loadend', syncBubble);
    }
    return xhrOpen.apply(this, arguments);
  };

  // also covers theme events (add / quantity change / remove)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncBubble);
  }
})();
